import { useTheme } from 'styled-components';

import { Message, MessageOptions, MessageType } from '@dreryk/react-components';

import { prescriptionsHistoryDownloadTranslationKeys } from './translations';

const useOptions = (): MessageOptions<{ [MessageType.NEGATIVE]: any }> => {
   const theme = useTheme();
   return {
      [MessageType.NEGATIVE]: {
         color: theme.error,
         backgroundColor: theme.errorLighter,
      },
   };
};

export const PatientWithoutPESELStatus = (): JSX.Element => {
   return (
      <Message
         testId={'patientWithoutPESEL'}
         type={MessageType.NEGATIVE}
         options={useOptions()}
         label={prescriptionsHistoryDownloadTranslationKeys.cantDownloadHistoryForPatientWithoutPESEL}
         displayIndicator
      />
   );
};
